import { requireNativeModule } from "expo";
import { Platform } from "react-native";

type AndroidAppLocalesModule = {
    getApplicationLocales: () => string;
    setApplicationLocales: (languageTags: string) => void;
};

function getNativeModule(): AndroidAppLocalesModule | null {
    if (Platform.OS !== "android") {
        return null;
    }

    try {
        return requireNativeModule<AndroidAppLocalesModule>("AndroidAppLocales");
    } catch {
        // Native module missing until a dev client / production build includes it.
        return null;
    }
}

/**
 * Sets Android per-app locales via AppCompatDelegate.setApplicationLocales.
 * No-op on iOS/web and when the native module is unavailable (e.g. Expo Go).
 *
 * @param languageTag BCP-47 tag such as "cs" or "en", or null/empty for system default.
 */
export function setAndroidApplicationLocales(
    languageTag: string | null | undefined
): void {
    getNativeModule()?.setApplicationLocales(languageTag?.trim() ?? "");
}

/**
 * First Android per-app locale tag (e.g. "cs" or "cs-CZ"), or null when the app
 * follows the device language / the native module is unavailable.
 */
export function getAndroidApplicationLocales(): string | null {
    const tags = getNativeModule()?.getApplicationLocales()?.trim();
    if (!tags) {
        return null;
    }
    return tags.split(",")[0] ?? null;
}
